import LocalImage from "@common/components/LocalImage";
import { useTranslation } from "next-i18next";
import ZeroPercentImage from "@public/images/car-zero-percent-en.png";

const ZeroPercentFinancingCard = () => {
  const { t } = useTranslation(["purchase"]);

  return (
    <div className="flex items-center justify-between bg-secondary-100 p-4 rounded-xl">
      <div className="flex flex-col space-y-1">
        <p className="text-lg font-semibold">
          {t("purchase:enjoy_your_zero_percent_financing")}
        </p>
        <p className="text-sm text-gray-600">
          {t("purchase:we_offer_zero_percent_interest")}
        </p>
      </div>

      {/* Mobile Image (150x35) */}
      <LocalImage
        className="block sm:hidden"
        src={ZeroPercentImage}
        alt="Zero Percent Financing"
        width={150}
        height={35}
        priority
      />

      {/* Larger Screens Image (250x50) */}
      <LocalImage
        className="hidden sm:block"
        src={ZeroPercentImage}
        alt="Zero Percent Financing"
        width={250}
        height={50}
        priority
      />
    </div>
  );
};

export default ZeroPercentFinancingCard;
